export default "__VITE_ASSET__648322fc__"